/* =====================================================================
   VELURA — fase 4: página de producto, añadir al carrito, carrito lateral
   ===================================================================== */
(function () {
  'use strict';
  const V = (window.Velura = window.Velura || {});
  V.modules = V.modules || {};
  const G = () => window.gsap;

  /* ---------------- CARRITO: añadir con animación ---------------- */
  function volar(desdeEl, src) {
    const g = G(), destino = document.getElementById('cart-icon-bubble');
    if (!g || !V.anim || !desdeEl || !destino || !src) return Promise.resolve();
    const a = desdeEl.getBoundingClientRect(), b = destino.getBoundingClientRect();
    const m = document.createElement('img');
    m.src = src; m.alt = ''; m.className = 'vl-vuelo';
    m.style.left = a.left + a.width / 2 - 36 + 'px'; m.style.top = a.top + a.height / 2 - 36 + 'px';
    document.body.append(m);
    const dx = b.left + b.width / 2 - (a.left + a.width / 2), dy = b.top + b.height / 2 - (a.top + a.height / 2);
    return new Promise((ok) => {
      g.timeline({ onComplete: () => { m.remove(); ok(); } })
        .fromTo(m, { scale: 0.4, opacity: 0 }, { scale: 1, opacity: 1, duration: 0.25, ease: 'back.out(2)' })
        .to(m, { x: dx, duration: 0.75, ease: 'power2.inOut' }, 0.2)
        .to(m, { y: dy, duration: 0.75, ease: 'back.in(1.6)' }, 0.2)
        .to(m, { scale: 0.25, opacity: 0.6, duration: 0.75, ease: 'power2.in' }, 0.2);
    });
  }

  async function agregar(id, cantidad, opts) {
    opts = opts || {};
    const drawer = document.querySelector('cart-drawer');
    const cuerpo = { items: [{ id: Number(id), quantity: Number(cantidad) || 1 }] };
    if (drawer) { cuerpo.sections = 'cart-drawer,cart-icon-bubble'; cuerpo.sections_url = location.pathname; }
    const r = await fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(cuerpo),
    });
    const datos = await r.json();
    if (!r.ok || datos.status) throw new Error(datos.description || datos.message || 'No se pudo agregar');
    await volar(opts.desde, opts.imagen);
    // si el carrito estaba vacío, Dawn lo marca con .is-empty y oculta la lista de productos: hay que quitarla
    if (drawer) drawer.classList.remove('is-empty');
    if (drawer && datos.sections) drawer.renderContents(datos);
    else location.href = (window.routes && window.routes.cart_url) || '/cart';
    return datos;
  }
  V.carrito = { agregar };

  // "¿Uno para regalar?" dentro del carrito
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-vl-upsell]');
    if (!b) return;
    e.preventDefault();
    b.classList.add('is-cargando');
    try { await agregar(b.dataset.vlUpsell, 1); } catch (err) { b.classList.remove('is-cargando'); }
  });

  /* ---------------- PÁGINA DE PRODUCTO ---------------- */
  V.modules.producto = function (el, ctx) {
    const { anim, fino } = ctx;
    const visor = el.querySelector('[data-vl-pdp-visor]');
    const slides = Array.from(el.querySelectorAll('.vl-pdp__slide'));
    const minis = Array.from(el.querySelectorAll('.vl-pdp__mini'));
    const ind = el.querySelector('[data-vl-pdp-ind]');
    const cont = el.querySelector('[data-vl-pdp-contador]');
    let act = 0;

    // las fotos que no se ven se cargan solo cuando hacen falta
    function cargar(i) {
      const s = slides[(i + slides.length) % slides.length];
      const img = s && s.querySelector('img[data-src]');
      if (!img) return;
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      img.src = img.dataset.src;
      img.removeAttribute('data-src'); img.removeAttribute('data-srcset');
    }
    function ir(i) {
      if (!slides.length) return;
      i = (i + slides.length) % slides.length;
      cargar(i); cargar(i + 1);
      if (i === act) return;
      desZoom();
      slides.forEach((s, k) => { s.classList.toggle('is-activa', k === i); s.setAttribute('aria-hidden', k !== i); });
      minis.forEach((m, k) => m.classList.toggle('is-activa', k === i));
      act = i;
      if (cont) cont.textContent = i + 1 + ' / ' + slides.length;
      moverInd();
    }
    function moverInd() {
      const m = minis[act];
      if (!ind || !m) return;
      ind.style.width = m.offsetWidth + 'px';
      ind.style.transform = `translateX(${m.offsetLeft}px)`;
      const c = m.parentElement;
      if (c.scrollWidth > c.clientWidth) c.scrollTo({ left: m.offsetLeft - c.clientWidth / 2 + m.offsetWidth / 2, behavior: 'smooth' });
    }
    minis.forEach((m, k) => m.addEventListener('click', () => ir(k)));
    const prev = el.querySelector('[data-vl-pdp-prev]'), next = el.querySelector('[data-vl-pdp-next]');
    if (prev) prev.addEventListener('click', () => ir(act - 1));
    if (next) next.addEventListener('click', () => ir(act + 1));
    addEventListener('resize', moverInd); setTimeout(moverInd, 60);
    // la segunda foto se prepara cuando la página ya está tranquila
    addEventListener('load', () => setTimeout(() => cargar(1), 1200));

    // deslizar con el dedo + zoom al tocar
    let x0 = null, y0 = 0, movio = false, zoom = false;
    function desZoom() { zoom = false; visor && visor.classList.remove('is-zoom'); slides.forEach((s) => (s.firstElementChild.style.transform = '')); }
    if (visor) {
      visor.addEventListener('pointerdown', (e) => { x0 = e.clientX; y0 = e.clientY; movio = false; });
      visor.addEventListener('pointermove', (e) => {
        if (zoom) {
          const r = visor.getBoundingClientRect();
          const px = (e.clientX - r.left) / r.width * 100, py = (e.clientY - r.top) / r.height * 100;
          slides[act].firstElementChild.style.transformOrigin = px + '% ' + py + '%';
          return;
        }
        if (x0 !== null && Math.abs(e.clientX - x0) > 8) movio = true;
      });
      visor.addEventListener('pointerup', (e) => {
        if (x0 === null) return;
        const dx = e.clientX - x0, dy = e.clientY - y0;
        if (!zoom && movio && Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) ir(act + (dx < 0 ? 1 : -1));
        else if (!movio && !e.target.closest('button')) {
          zoom = !zoom; visor.classList.toggle('is-zoom', zoom);
          const img = slides[act].firstElementChild, r = visor.getBoundingClientRect();
          img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
          img.style.transform = zoom ? 'scale(2.1)' : '';
        }
        x0 = null;
      });
      visor.addEventListener('pointerleave', () => { if (fino && zoom) desZoom(); x0 = null; });
      visor.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') ir(act + 1); if (e.key === 'ArrowLeft') ir(act - 1); });
    }

    // cantidad
    const cant = el.querySelector('[data-vl-pdp-cant]');
    const menos = el.querySelector('[data-vl-pdp-menos]'), mas = el.querySelector('[data-vl-pdp-mas]');
    const fijar = (n) => { if (cant) cant.value = Math.max(1, Math.min(10, n)); };
    if (menos) menos.addEventListener('click', () => fijar(+cant.value - 1));
    if (mas) mas.addEventListener('click', () => fijar(+cant.value + 1));

    // packs: 1 o 2 unidades (el precio del pack lo aplica el descuento automático de Shopify)
    const packs = Array.from(el.querySelectorAll('.vl-pack'));
    let precioPack = null;
    let packElegido = false; // true cuando la clienta toca un pack en la página
    packs.forEach((p) => p.querySelector('input').addEventListener('change', () => {
      packElegido = true;
      packs.forEach((x) => x.classList.toggle('is-activo', x === p));
      if (cant) cant.value = p.querySelector('input').value;
      const pagar = el.querySelector('[data-vl-pdp-pagar]');
      if (pagar) pagar.setAttribute('href', pagar.getAttribute('href').replace(/:\d+$/, ':' + p.querySelector('input').value));
      precioPack = p.dataset.precio;
      // el precio grande (y el de la barra fija) muestran el del pack elegido
      el.querySelectorAll('[data-vl-pdp-precio]').forEach((x) => (x.textContent = precioPack));
      const enBarra = document.querySelector('.vl-pdp__barra [data-vl-pdp-precio]');
      if (enBarra) enBarra.textContent = precioPack;
      const antesEl = el.querySelector('[data-vl-pdp-antes]');
      if (antesEl) { antesEl.hidden = !p.dataset.antes; if (p.dataset.antes) antesEl.textContent = p.dataset.antes; }
      const precioEl = el.querySelector('.vl-pdp__actual');
      if (precioEl && V.anim && G()) G().fromTo(precioEl, { y: 8, opacity: 0.3 }, { y: 0, opacity: 1, duration: 0.45, ease: 'power3.out' });
      if (V.anim && G()) G().fromTo(p, { scale: 0.98 }, { scale: 1, duration: 0.5, ease: 'back.out(3)' });
    }));

    // variantes (solo si el producto tiene opciones)
    const idInput = el.querySelector('[data-vl-pdp-id]');
    const selects = Array.from(el.querySelectorAll('[data-vl-pdp-opcion]'));
    const precios = Array.from(el.querySelectorAll('[data-vl-pdp-precio]'));
    const antes = el.querySelector('[data-vl-pdp-antes]');
    const boton = el.querySelector('[data-vl-pdp-boton]');
    const btxt = el.querySelector('[data-vl-pdp-btxt]');
    const textoBoton = btxt ? btxt.textContent : '';
    const fmt = (c) => {
      const f = el.dataset.dinero || '${{amount}}';
      const n = (c / 100).toFixed(2), [e, d] = n.split('.'), mil = e.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return f.replace(/\{\{\s*amount_no_decimals\s*\}\}/, mil).replace(/\{\{\s*amount\s*\}\}/, mil + '.' + d)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, e.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + d);
    };
    const json = el.querySelector('[data-vl-pdp-variantes]');
    if (json && selects.length) {
      const variantes = JSON.parse(json.textContent);
      selects.forEach((s) => s.addEventListener('change', () => {
        const vals = selects.map((x) => x.value);
        const v = variantes.find((x) => x.options.every((o, k) => o === vals[k]));
        if (!v) { boton.disabled = true; btxt.textContent = 'No disponible'; return; }
        idInput.value = v.id;
        precios.forEach((p) => (p.textContent = fmt(v.price)));
        if (antes) { antes.hidden = !(v.compare_at_price > v.price); antes.textContent = fmt(v.compare_at_price || 0); }
        boton.disabled = !v.available; btxt.textContent = v.available ? textoBoton : 'Agotado por ahora';
        const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u);
        if (v.featured_media) { const k = slides.findIndex((sl) => sl.querySelector('img').src.includes(String(v.featured_media.preview_image && v.featured_media.preview_image.src || '').split('?')[0].split('/').pop())); if (k > -1) ir(k); }
      }));
    }

    // añadir al carrito: texto → cargando → ✓ → miniatura que vuela → carrito
    const form = el.querySelector('[data-vl-pdp-form]');
    const error = el.querySelector('[data-vl-pdp-error]');
    async function comprar(desde) {
      if (!boton || boton.disabled || boton.dataset.estado === 'cargando') return;
      if (error) error.hidden = true;
      boton.dataset.estado = 'cargando';
      const img = slides[act] ? slides[act].querySelector('img') : null;
      try {
        await agregar(idInput.value, cant ? cant.value : 1, { desde: desde || boton, imagen: img ? img.currentSrc || img.src : null });
        boton.dataset.estado = 'hecho';
        setTimeout(() => (boton.dataset.estado = 'listo'), 1600);
      } catch (err) {
        boton.dataset.estado = 'listo';
        if (error) { error.textContent = err.message; error.hidden = false; }
      }
    }
    // contra entrega (Releasit): su botón sustituye al nuestro; el formulario y la barra fija lo abren
    const cod = el.classList.contains('vl-pdp--cod');
    const botonCod = () => el.querySelector('#rsi-button-hook > button');
    const abrirCod = () => { const b = botonCod(); if (b) { b.click(); return true; } return false; };
    // al abrir el formulario de Releasit, si la clienta eligió un pack en la página, marca esa misma oferta;
    // si no tocó nada, se respeta la oferta que Releasit trae preseleccionada (el pack de 2).
    // (las ofertas de Releasit van en orden: quantity_0 = 1 unidad, quantity_1 = 2 unidades…)
    if (cod) document.addEventListener('click', (e) => {
      if (!e.target.closest('#rsi-button-hook > button')) return;
      if (!packElegido) return;
      const n = cant ? +cant.value : 1;
      let intentos = 0;
      const marcar = () => {
        const r = document.querySelector('input[name="quantity_offer"][value="quantity_' + (n - 1) + '"]');
        if (r) { if (!r.checked) (r.closest('label') || r).click(); return; }
        if (++intentos < 30) setTimeout(marcar, 150);
      };
      setTimeout(marcar, 200);
    }, true);
    if (form) form.addEventListener('submit', (e) => { e.preventDefault(); if (cod && abrirCod()) return; comprar(); });

    // barra fija en el celular: aparece cuando el botón principal sale de pantalla
    const barra = el.querySelector('[data-vl-pdp-barra]');
    const bb = el.querySelector('[data-vl-pdp-barra-btn]');
    if (barra) {
      document.body.append(barra);
      if (bb) bb.addEventListener('click', () => { if (cod && abrirCod()) return; comprar(bb); });
      if (boton && 'IntersectionObserver' in window) {
        new IntersectionObserver(([en]) => {
          const ver = !en.isIntersecting && en.boundingClientRect.top < 0;
          barra.classList.toggle('is-visible', ver);
          barra.setAttribute('aria-hidden', !ver);
          if (bb) bb.tabIndex = ver ? 0 : -1;
        }).observe(cod && form ? form : boton);
      }
    }
  };
})();
